import { useMemo } from "react"
import { useNbrAuth } from "@/app/auth/useNbrAuth"
import { useNbrPermissions } from "@/app/auth/useNbrPermissions"
import { useWorkspaces } from "@/shared/api/queries"
import { roleCabinetsFromWorkspaces, type CabinetAccess } from "./cabinetNav"

export const useCabinetAccess = (): CabinetAccess & { isLoading: boolean } => {
  const auth = useNbrAuth()
  const perms = useNbrPermissions()
  const workspaces = useWorkspaces(auth.isAuthenticated)
  const items = workspaces.data?.items

  const available = useMemo(() => roleCabinetsFromWorkspaces(items), [items])

  return {
    isLoading: auth.isLoading || (auth.isAuthenticated && (workspaces.isLoading || perms.isLoading)),
    isAdmin: auth.isAdmin,
    available,
    canCreateEvents: perms.canCreateEvents,
    canModerateEvents: perms.canModerateEvents,
    canModerateDeposits: perms.canModerateDeposits,
    canManageAssociations: perms.canManageAssociations,
    canViewEventAudit: perms.canViewEventAudit,
    canViewDepositAudit: perms.canViewDepositAudit,
    canManageCreativeCatalog: perms.canManageCreativeCatalog,
  }
}
